// extracted by mini-css-extract-plugin
module.exports = {"form":"BankIDAuth__form--X7Z","submitButtonContainer":"BankIDAuth__submitButtonContainer--1L4","formError":"BankIDAuth__formError--3LA"};